import FieldFactory from './FieldFactory.js'

const listField = /^\((?<listItems>[a-zA-Z0-9, ._()*/+\-:']*)\)$/

export default {
  id : 'Expression.FieldParser.ListField',
  type : 'listField',
  sort : 4,
  handles : ( field, context ) => {
    if ( field.type !== 'ExpressionParser.Field' ) {
      return false
    }
    return field.value?.match( listField )
  },
  parse : async ( field, context ) => {
    const value = field.value

    const match = value.match( listField )
    const list = await FieldFactory.create(
      match.groups.listItems,
      { ...context, field : { ...field, type : 'ExpressionField.list' }, indexOffset : 1 }
    )

    const toReturn = {
      type : 'ExpressionField.list',
      value : list.fields,
    }
    if ( context?.includeAstInfo ) {
      toReturn.absoluteLocation = {
        startIndex : field.startIndex,
        endIndex : field.endIndex,
      }
      toReturn.relativeLocation = {
        startIndex : 0,
        endIndex : field.untrimmed?.length
      }
      toReturn.commaLocations = list.commaLocations
      toReturn.untrimmed = field.untrimmed
    }
    return toReturn
  }
}
